var map = {
	"./demos/always/index.ts": 78395,
	"./demos/basic/index.ts": 41961,
	"./demos/content/index.ts": 16539,
	"./demos/position/index.ts": 79052,
	"./demos/trigger/index.ts": 32218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53796;